import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CustomStatus, MetaStatus, PageResponse, StatusType } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class CustomStatusService {
  private apiUrl = `${environment.apiUrl}/statuses`;
  private statusesSubject = new BehaviorSubject<CustomStatus[]>([]);
  statuses$ = this.statusesSubject.asObservable();

  constructor(private http: HttpClient) { }

  getAll(type: StatusType | 'ALL' = StatusType.PROJECT): Observable<CustomStatus[]> {
    const params = new HttpParams().set('type', type);
    return this.http.get<CustomStatus[]>(this.apiUrl, { params }).pipe(
      tap(statuses => this.statusesSubject.next(statuses))
    );
  }

  getPage(search = '', page = 0, size = 10, sort = 'name,asc', showArchived = false, metaStatus: MetaStatus | 'ALL' = 'ALL', type: StatusType | 'ALL' = 'ALL'): Observable<PageResponse<CustomStatus>> {
    const params = new HttpParams()
      .set('search', search)
      .set('page', String(page))
      .set('size', String(size))
      .set('sort', sort)
      .set('showArchived', String(showArchived))
      .set('metaStatus', metaStatus)
      .set('type', type);

    return this.http.get<PageResponse<CustomStatus>>(`${this.apiUrl}/page`, { params });
  }

  create(status: CustomStatus): Observable<CustomStatus> {
    return this.http.post<CustomStatus>(this.apiUrl, status).pipe(
      tap(() => this.getAll().subscribe())
    );
  }

  update(id: number, status: CustomStatus): Observable<CustomStatus> {
    return this.http.put<CustomStatus>(`${this.apiUrl}/${id}`, status).pipe(
      tap(() => this.getAll().subscribe())
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      tap(() => this.getAll().subscribe())
    );
  }

  canDelete(id: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/${id}/can-delete`);
  }

  validateConfig(type: StatusType | 'ALL' = StatusType.PROJECT): Observable<boolean> {
    const params = new HttpParams().set('type', type);
    return this.http.get<boolean>(`${this.apiUrl}/validate-config`, { params });
  }
}
